import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CHOICE } from "./abstract/choiceAbstract";

const _action = `${ACTION_PREFIX_CHOICE}_create`;
const _header = `Create choice`;

export const addChoice = (root, idParent, body, index) => {
  const _payload = addChoiceLogic(root, idParent, body, index);

  logger.logAction(_action, _payload, ACTION_PREFIX_CHOICE);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const addChoiceLogic = (root, idParent, body, index) => {
  const { data: _nodeParent } = getNodeById(root, idParent);

  if (!_nodeParent) {
    throw new Error ('Parent node not found');
  }

  const _indexParsed = index ?? nodeUtils.getChoices(_nodeParent).length;

  const fun = (e) => e.splice(_indexParsed, 0, body);
  nodeUtils.modifyChoices(_nodeParent, fun, false);

  return generatePayload(body, _indexParsed, _nodeParent);
};

//--------------------------------------------------------------------------------

const generatePayload = (body, index, nodeParent) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(nodeParent),
    node: systemUtils.createDeepCopy(body),
    uuid: nodeUtils.getUUID(body),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  return _payload;
};

const generatePayloadDescription = (nodeParent) => {

    return `Add a new choice to '${nodeUtils.getName(nodeParent)}'.`;
}